import { createContext, useReducer } from "react";
import { initialState, reducer } from "../reducers";

export const NutritionContext = createContext({});

export const NutritionProvider = ({ panelInfo, children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return <NutritionContext.Provider value={{ state, dispatch, panelInfo }}>{children}</NutritionContext.Provider>;
};
